import axiosInstance from "@/lib/axios";

export const productRequestService = {
  getProductRequests: async ({ page = 1 }) => {
    const response = await axiosInstance.get("/api/v1/admin/product-requests", {
      params: { page },
    });
    return response.data;
  },

  // Retrait admin (contenu inapproprié/abusif) — en plus de la suppression
  // par le demandeur lui-même ("marquer trouvé") côté mobile.
  deleteProductRequest: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/admin/product-requests/${id}`);
    return response.data;
  },
};

export default productRequestService;
